/**
 * Réglage « Densité » (1 à 5) du fond Écrans de veille : un seul curseur pour « combien de choses à l'écran », que chaque écran
 * traduit en ses propres quantités. Le niveau 3 est la valeur d'origine de chaque écran.
 */
export const NIVEAUX = {
    formes: [1, 1, 2, 2, 3],           // Mystify : polygones
    traine: [3, 4, 6, 8, 10],          // Mystify : images de traînée derrière chaque polygone
    etoiles: [20, 40, 60, 80, 100],    // ciel d'étoiles
    bulles: [10, 20, 30, 40, 50],      // bulles
};

/** Quantités de chaque écran pour une densité donnée (ramenée entre 1 et 5). */
export function quantites(densite) {
    const n = Math.round(Number(densite));
    const i = Math.max(1, Math.min(5, Number.isFinite(n) ? n : 3)) - 1;
    return Object.keys(NIVEAUX).reduce((acc, cle) => ({...acc, [cle]: NIVEAUX[cle][i]}), {});
}
